/**
 * The sidebars of the two consoles that are not a firm.
 * @file src/web/shared/console-nav.ts
 *
 * Deliberately NOT named nav.*.ts: those files are globbed into the firm
 * app's sidebar, and a firm admin must not see "Clients" or "Partners".
 */
import { Building2, Gauge, Handshake, Layers, ScrollText, SlidersHorizontal, Users } from 'lucide-react';
import type { NavItem } from './nav.base';

export const PLATFORM_NAV: NavItem[] = [
  { to: '/platform', label: 'Dashboard', icon: Gauge, end: true, section: 'Platform', order: 10 },
  { to: '/platform/clients', label: 'Clients', icon: Building2, order: 20 },
  { to: '/platform/partners', label: 'Partners', icon: Handshake, order: 30 },
  { to: '/platform/team', label: 'Team', icon: Users, order: 35 },
  { to: '/platform/audit', label: 'Audit log', icon: ScrollText, order: 38, ownerOnly: true },
  { to: '/platform/plans', label: 'Plans', icon: Layers, section: 'Configuration', order: 40, ownerOnly: true },
  { to: '/platform/settings', label: 'Global settings', icon: SlidersHorizontal, order: 50, ownerOnly: true },
];

export const PARTNER_NAV: NavItem[] = [
  { to: '/partner', label: 'Your firms', icon: Building2, end: true, section: 'Partner', order: 10 },
  { to: '/partner/team', label: 'Team', icon: Users, order: 20 },
];
